import type { SettingsDropdownProps } from './interfaces';
import React from 'react';

import { Dropdown } from 'semantic-ui-react';

export const SettingsDropdown: React.FC<SettingsDropdownProps> = ({
  label,
  options,
  onChange,
  value,
  icon,
  testid,
}) => (
  <div className="settings-select semantic-flex-column">
    <span className="sub-headers settings-select--label">{label}</span>
    <div className="semantic-flex-align-items-center semantic-flex-row">
      <Dropdown
        {...{ options, onChange, value }}
        data-testid={testid}
        className="IOput settings-select--dropdown"
        placeholder="Select an option"
      />
      <div className="semantic-flex-row semantic-flex-align-items-center">
        <img alt="icon" src={icon} />
      </div>
    </div>
  </div>
);
